import { useEffect, useRef } from "react";

// Startet `start` hoechstens einmal je `key` (etwa eine Sitzungs-Id), sobald
// `ready` wahr wird. Fuer Auto-Starts, deren Bedingung nach einem Fehlschlag
// wieder wahr wird: im Labor loeste jeder gescheiterte Lauf sofort den
// naechsten aus, die Fehlermeldung verschwand dabei jedes Mal, und jeder
// Durchlauf kostete einen Modellaufruf (2026-10-06). Ein neuer `key` darf
// wieder einmal starten.
export function useAutoStartOnce(key: string | undefined, ready: boolean, start: () => void): void {
  const startedFor = useRef<string | undefined>(undefined);
  useEffect(() => {
    if (!ready || key === undefined || startedFor.current === key) return;
    startedFor.current = key;
    start();
    // start bewusst nicht in den Abhaengigkeiten: die Aufrufer reichen eine
    // bei jedem Rendern neue Funktion, die sonst bei jedem Rendern feuern wuerde.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, ready]);
}
